import React from "react";
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@mui/material/Autocomplete';

const Dropdown = props => {
    const options = Array.isArray(props.options) ? props.options : [];

    const getOptionLabel = (option) => {
        if (!option || typeof option !== 'object') {
            return '';
        }
        const primary = option[props.label];
        if (props.label1) {
            const secondary = option[props.label1];
            return [primary, secondary].filter(Boolean).join('-');
        }
        return primary != null ? String(primary) : '';
    };

    const value = Array.isArray(props.value) ? null : (props.value || null);

    return (
        <FormControl variant="outlined" className="w-100">
            <Autocomplete
                disabled={props.disabled}
                value={value}
                size="small"
                onChange={(e, value) => props.onChange(e, value)}
                id={props.id}
                options={options}
                getOptionLabel={getOptionLabel}
                isOptionEqualToValue={(option, val) => option?.id === val?.id}
                renderInput={(params) => <TextField {...params} label={props.placeholder} />}
            />
            {
                props.formError && (
                    <p className="text-danger small pt-2">
                        {props.formError.join('. ')}
                    </p>
                )}
        </FormControl>
    );
};

export default Dropdown;

